import { Tabs } from "antd";
import { Schools } from "./components/Schools";
import "./index.scss";
import TrustRequests from "./components/TrustRequests";
import { Text } from "@fluentui/react-northstar";
import TrustedNetworks from "./components/TrustedNetworks";
import Groups from "./components/Groups";
import { useTranslation } from "react-i18next";
import React, { useMemo } from "react";
import { Subscription } from "../../components/Subscription/Subscription";

const Wrapper = ({ children, title }) => {
  return (
    <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Text
        content={title}
        size="large"
        align="center"
        weight="bold"
        style={{ marginBottom: "10px", flexShrink: 0 }}
      />
      <div
        style={{
          padding: "10px",
          flex: 1,
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </div>
    </div>
  );
};
export const TrustedNetwork = (props) => {
  const { t } = useTranslation();
  const tabsTranslation = t("trustedNetwork").tabs;
  const titlesTranslation = t("trustedNetwork").titles;
  const user =
    props?.user || JSON.parse(localStorage.getItem("userinfo")) || {};
  const dayRemaining = user?.dbData?.dayRemaining ?? 1;
  if (dayRemaining <= 0) {
    return (
      <Subscription
        pageName="trustednetwork"
        isExpire={true}
        role={user?.role || ""}
      />
    );
  }
  return (
    <div className="trusted-network-container">
      <Tabs
        style={{ padding: "0 20px" }}
        defaultActiveKey="schools"
        items={[
          {
            key: "schools",
            label: tabsTranslation.schools,
            children: (
              <Wrapper title={titlesTranslation.schools}>
                <Schools />
              </Wrapper>
            ),
          },
          {
            key: "requests",
            label: tabsTranslation.requests,
            children: (
              <Wrapper title={titlesTranslation.requests}>
                <TrustRequests />
              </Wrapper>
            ),
          },
          {
            key: "networks",
            label: tabsTranslation.networks,
            children: (
              <Wrapper title={titlesTranslation.networks}>
                <TrustedNetworks />
              </Wrapper>
            ),
          },
          {
            key: "groups",
            label: tabsTranslation.groups,
            children: (
              <Wrapper title={titlesTranslation.groups}>
                <Groups />
              </Wrapper>
            ),
          },
        ]}
      />
    </div>
  );
};
